import { fetchLogin, getUser, getAllUsers, fetchLogout } from "../api/users.api";
import * as usersConst from "../const/users.const";

export const login = (email, password) => ({
    type: usersConst.LOGIN,
    payload: fetchLogin(email, password)
});

export const user = () => ({
    type: usersConst.USER,
    payload: getUser()
});

export const getUsers = () => ({
    type: usersConst.GET_ALL_USERS,
    payload: getAllUsers()
});

export const logout = () => ({
    type: usersConst.LOGOUT,
    payload: fetchLogout()
});
